import { axiosInstance } from '../../services/axiosInstance'
import { ActionRequest, ActionResponse } from './actionService.types'

export async function executeAction<ActionRequestInputParams, ActionResponseData>(
	request: ActionRequest<ActionRequestInputParams>,
): Promise<ActionResponse<ActionResponseData>> {
	const { data } = await axiosInstance.post('/workflow/actions/', request)
	return data
}
